import script from "./WebQuotesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebQuotesView.vue?vue&type=script&lang=ts&setup=true"

import "./WebQuotesView.vue?vue&type=style&index=0&id=069c281c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069c281c"]])

export default __exports__